import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend, configure } from 'vee-validate';
import { required, min, email } from 'vee-validate/dist/rules';
import isCreditCard from 'validator/lib/isCreditCard';
import isPhone from 'validator/lib/isMobilePhone';
import moment from 'moment';
import _ from 'lodash';
import lsCycleFilter from '@/filters/ls-cycle.filter';
import lsDateFilter from '@/filters/ls-date.filter';
import lsMoneyFilter from '@/filters/ls-money.filter';
import lsServiceNameFilter from '@/filters/ls-service-name.filter';

const currentDate = moment().toDate();
const currentYear = currentDate.getFullYear() - 2000;
const currentMonth = currentDate.getMonth() + 1;

Vue.filter('lsCycle', lsCycleFilter);
Vue.filter('lsDate', lsDateFilter);
Vue.filter('lsMoney', lsMoneyFilter);
Vue.filter('lsServiceName', lsServiceNameFilter);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
configure({
    classes: {
        invalid: 'ls-invalid',
    },
});
extend('required', required);
extend('min', min);
extend('email', email);
extend('isNotDuplicateEmail', {
    params: ['duplicateEmail'],
    validate(value, { duplicateEmail }) {
        return _.toUpper(value) !== _.toUpper(duplicateEmail);
    },
});
extend('hasPlaceId', {
    params: ['address'],
    validate(value, { address }) {
        return !!address.googlePlace.place_id;
    },
});
extend('hasStreetNumber', {
    params: ['address'],
    validate(value, { address }) {
        return !!address.googlePlace.street_number || !!address.manualStreetNumber;
    },
});
extend('isCreditCard', isCreditCard);
extend('isPhone', {
    validate(value) {
        const nonNumberRegex = /[^0-9]+/g;
        const numbersOnly = _.replace(`${value}`, nonNumberRegex, '');
        return isPhone(numbersOnly, 'en-US');
    },
});
extend('exp_month', {
    params: ['target'],
    validate(value, { target }) {
        return !(Number(target) === currentYear && Number(value) <= currentMonth);
    },
});
extend('exp_year', {
    params: ['target'],
    validate(value, { target }) {
        return !(Number(value) === currentYear && Number(target) <= currentMonth);
    },
});
